<script lang="ts" setup>
import { computed } from 'vue';
import { MAX_NAME_LENGTH } from '@/constants';
import { NotificationReplyCommentType } from '@/types';
import { getArticlePageUrl } from '@/utils';
import { formatUserName } from '@/utils/formatters';
import CardTemplate from './card-template.vue';

// WARN: 通知の表記を変更するときは serviceWorkerHelper.ts の変更漏れがないかも確認する
// WARN: 通知のURLを変更するときは web-push.vue の変更漏れがないかも確認する

interface Props {
  notification: NotificationReplyCommentType;
  isUnread: boolean;
}

const props = defineProps<Props>();

const url = computed(() =>
  props.notification.document
    ? getArticlePageUrl(
        props.notification.document,
        props.notification.comment.id,
      )
    : `/comments/${props.notification.comment.id}`,
);
const formattedUserName = computed(() => {
  return formatUserName(
    props.notification.creator_name,
    props.notification.is_deleted_creator,
    MAX_NAME_LENGTH,
  );
});
</script>
<template>
  <CardTemplate
    :type="notification.type"
    :url="url"
    :is-unread="isUnread"
    :created-at="notification.created_at"
    :user-id="notification.creator_id"
    :image-url="notification.creator_image_url"
    :content-title="notification.document?.title"
    :preview="notification.comment.content"
    :group-name="notification.group.name"
  >
    {{ formattedUserName }}さんがあなたのコメントに返信しました。
  </CardTemplate>
</template>
